<div
  #navbarEl
  class="atn-navbar"
  [class.atn-navbar--expanded]="store.expandedSg()"
  [style.background-color]="store.colorSg()"
  (mouseenter)="store.hoverStart()"
  (mouseleave)="store.hoverEnd()"
  data-test-id="navbar"
>
  <atn-navbar-logo class="atn-navbar__logo" />
  <atn-navbar-app-list class="atn-navbar__apps" />
  <atn-ds-divider class="atn-navbar__footer-divider" />
  <atn-navbar-footer class="atn-navbar__footer" />
</div>

@if (store.configHasRecentlyChangedSg()) {
  @let config = store.configSg();

  <atn-ds-splash-screen
    class="atn-navbar__transition-splash-screen"
    [title]="config.title"
    [subtitle]="config.subtitle"
    [color]="config.color"
    [logo]="config.logo.collapsed"
    [noDelay]="true"
  />
}
